import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownTimer } from './components/CountdownTimer';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { ResultsSection } from './components/ResultsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { UpsellSection } from './components/UpsellSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-green-100 selection:text-green-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownTimer data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ResultsSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <UpsellSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <FAQSection data-id="element-13" />
      </main>

      <FooterSection data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}